<div class="section-header"><h1><slot name="header"></slot></h1><h2><slot name="subheader"></slot></h2></div>